/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================
* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
Coded by www.creative-tim.com
 =========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import profileIcon from "assets/images/Profile-1.svg";
import profileIconDark from "assets/images/Profile.svg";
import MDBadge from "components/MDBadge";
import { useMaterialUIController } from "context";
import moment from "moment/moment";
import { CloseRounded } from "@mui/icons-material";
import MDButton from "components/MDButton";
import {
  GetAllUsersWithSandboxTech,
  UpdateAPIStatusTech,
  OnboardingForm,
} from "api-services";
import "./users.css";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import { ShowSuccessMessage } from "helpers";

const Author = ({ name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDBox lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

const Job = ({ title }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography
      display="block"
      variant="caption"
      color="text"
      fontWeight="medium"
    >
      {title}
    </MDTypography>
  </MDBox>
);
// Sandbox
const Products = ({ myAPI }) => {
  myAPI = myAPI.sort((a, b) => (a.name > b.name ? 1 : -1));
  return (
    <MDBox sx={{ display: "flex", flexDirection: "column" }}>
      {myAPI.map((item) => (
        <MDBadge
          key={item?.apiid}
          badgeContent={item?.name}
          sx={{ marginBottom: "5px" }}
          color={getProductBadgeColor(item?.apiid)}
          variant="gradient"
          size="sm"
        />
      ))}
    </MDBox>
  );
};

const getProductBadgeColor = (id) => {
  return "light";
};

const CustomCheckBox = ({ product, handleProductChange }) => {
  const [checked, setChecked] = useState(true);
  const handleChange = (id, value) => {
    handleProductChange(id, value);
    setChecked(value);
  };
  return (
    <MDBox sx={{ display: "flex" }}>
      <Checkbox
        checked={checked}
        onChange={(e) => handleChange(product?.apiid, e.target.checked)}
      />
      {/* <Checkbox checked={checked} onChange={(e) => setChecked(!checked)} /> */}
      <MDTypography variant="subtitle2" mt={0.6}>
        {product?.name}
      </MDTypography>
    </MDBox>
  );
};
const Field = ({ label, content }) => (
  <div>
    <MDTypography variant="h6" sx={{ fontSize: "16px", marginBottom: 0 }}>
      {label}
    </MDTypography>
    <MDTypography variant="body1" sx={{ fontSize: "14px", marginBottom: 4 }}>
      {content || "N/A"}
    </MDTypography>
  </div>
);
function Users() {
  useEffect(() => {
    GetAllUsersWithSandboxTech(
      dispatchData,
      successAction,
      errorAction,
      "",
      "1",
      "A",
      "A",
      selectedSandboxStatusTechTab
    );
    // GetAllRoles(dispatchData, (res) => setRoles(res.data), errorAction);
  }, []);

  const [rows, setRows] = useState([]);

  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [selectedItem, setSelectedItem] = useState();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openForm, setOpenForm] = useState(false);
  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => setOpenForm(false);

  const { loading } = useSelector((state) => state.authentication);

  const { user_data } = useSelector((state) => state.authentication);

  //Download
  const [downloadData, setDownloadData] = useState(null);

  // Sandbox
  const [errorSandbox, setErrorSandbox] = useState("");
  const [successSandbox, setSuccessSandbox] = useState(false);
  const [failedSandbox, setFailedSandbox] = useState("");
  const SandboxFilterFetch = window.location.hash.substring(1);
  const getSandboxStatus = (SandboxFilterFetch) => {
    if (SandboxFilterFetch === "") return "all";
    switch (SandboxFilterFetch) {
      case "aLL":
        return "all";
      case "A":
        return "A";
      case "P":
        return "P";
      case "R":
        return "R";
      case "W":
        return "W";
      default:
        return "all";
    }
  };

  const [selectedSandboxStatusTechTab, setSelectedSandboxStatusTechTab] =
    useState(getSandboxStatus(SandboxFilterFetch));

  const [dataLoading, setDataLoading] = useState(true);
  const [statusValue, setStatusValue] = useState("");

  const [priviousStatus, setPriviousStatus] = useState("");
  const [identifier, setIdentifier] = useState("");
  const dispatchData = useDispatch();

  let bgColor = darkMode ? "#1a2035" : "#fff";

  const validateCheckBoxes = () => {
    let flag = false;
    selectedItem?.myAPI?.forEach((item) => {
      if (item.checked) {
        flag = true;
      }
    });

    return flag;
  };

  // Get Form Details
  const getFormDetails = (item) => {
    item?.myAPI.map((item) => {
      OnboardingForm(
        (res) => {
          setIdentifier(res.data);
        },
        errorAction,
        item.identifier
      );
    });
  };

  // Tech Status
  const handleSubmitSandbox = () => {
    setErrorSandbox("");
    setSuccessSandbox(false);
    setFailedSandbox("");

    if (statusValue == priviousStatus) {
      setErrorSandbox("Please select Tech status!");
    } else {
      let productsData = (selectedItem?.myAPI || [])
        .filter((i) => i.checked)
        .map((item) => {
          return {
            identifier: item.identifier,
            status: item.newStatus,
            accessType: item?.access_type,
            // userName: item?.userName,
            // password: item?.password,
            // baseURL: item?.baseURL
          };
        });

      const data = {
        products: productsData,
      };
      if (validateCheckBoxes() && statusValue != priviousStatus) {
        //Only work when status is changed
        // debugger
        UpdateAPIStatusTech(
          dispatchData,
          data,
          () => {
            GetAllUsersWithSandboxTech(
              dispatchData,
              successAction,
              errorAction,
              "",
              "1",
              "A",
              "A",
              selectedSandboxStatusTechTab
            );
            setSuccessSandbox(true);
            setTimeout(() => {
              handleClose();
              setErrorSandbox("");
              setSuccessSandbox(false);
              setFailedSandbox(false);
            }, 1000);
          },
          () => {
            setFailedSandbox(true);
          },
          clearFields
        );
      }
    }
  };

  const handleTabChangeSandboxTechStatus = (techstatus) => {
    setDataLoading(true);
    setSelectedSandboxStatusTechTab(techstatus);
    GetAllUsersWithSandboxTech(
      dispatchData,
      successAction,
      errorAction,
      "",
      "1",
      "A",
      "A",
      techstatus
    );
  };

  // Sanbox
  const handleCheckboxChanged = (id, value) => {
    if (selectedItem) {
      const products = selectedItem.myAPI.map((item) => {
        if (item.apiid == id) {
          item.checked = value;
        }

        return item;
      });
      setSelectedItem({ ...selectedItem, myAPI: products });
      updateAPIStatuses(statusValue);
    }
  };
  const updateAPIStatuses = (status) => {
    if (selectedItem) {
      const products = selectedItem.myAPI.map((item) => {
        // Update newStatus based on whether item.checked is true
        item.newStatus = item.checked ? status : item.status;
        return item;
      });
      setSelectedItem({ ...selectedItem, myAPI: products });
    }
  };

  const columns = [
    { Header: "name", accessor: "name", align: "left" },
    { Header: "company name", accessor: "company_name", align: "left" },
    { Header: "company website", accessor: "company_website", align: "left" },
    { Header: "job role", accessor: "job_role", align: "left" },
    {
      Header: "product name",
      accessor: "product_name",
      width: "10%",
      align: "left",
    },
    {
      Header: "tech status",
      accessor: "tech_status",
      width: "10%",
      align: "left",
    },
    {
      Header: "registered on",
      accessor: "registered_on",
      width: "9%",
      align: "left",
    },
    { Header: "Onboarding Form", accessor: "form", width: "9%", align: "left" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const successAction = (res) => {
    setDataLoading(false);

    const getFullName = (firstName, lastName) => {
      return `${firstName} ${lastName || ""}`;
    };

    const getCompanyName = (name) => name || "N/A";

    const getCompanyWebsite = (website) =>
      website ? `https://${website}` : "";

    const getTechStatusColor = (status) => {
      switch (status) {
        case "A":
          return "success";
        case "P":
          return "warning";
        case "R":
          return "info";
        default:
          return "error";
      }
    };

    const handleMapAPI = (item) => {
      return item.myAPI.map((api) => ({
        ...api,
        checked: true,
        access_type: "Sandbox",
        newStatus: api.techStatus,
      }));
    };

    const getAPIStatus = (status) => {
      switch (status) {
        case "A":
          return "Approved";
        case "P":
          return "Pending";
        case "R":
          return "In Review";
        case "I":
          return "Suspended";
        case "W":
          return "Rejected";
        default:
          return "N/A";
      }
    };

    function getDataForDownload(userData) {
      setDownloadData(null);

      const csvData = userData.map((user) => {
        // Aggregate API names and their statuses
        const apiDetails = user.myAPI.map((api) => ({
          name: api.name ? api.name : "N/A",
          status: getAPIStatus(api.techStatus), // Use getAPIStatus to get the status description
        }));

        // Create strings for API names and statuses
        const apiNames = apiDetails.map((api) => api.name).join(", ");
        const apiStatuses = apiDetails.map((api) => api.status).join(", ");
        console.log(user);
        return {
          Name: user.fullName,
          "Company Name": user.companyName ? user.companyName : "N/A",
          "Company Website": user.companyWebSite ? user.companyWebSite : "N/A",
          "Job Role": user.jobRole ? user.jobRole : "N/A",
          "Product Name": apiNames,
          "Tech Status": apiStatuses,
          "Registered On": moment(user.createdOn).format("MM/DD/yyyy"),
        };
      });

      setDownloadData(csvData);
    }

    const allUsers = res.data.map((item) => {
      getDataForDownload(res.data);
      const fullName = getFullName(item.firstName, item.lastName);

      return {
        name: (
          <Author
            image={darkMode ? profileIcon : profileIconDark}
            name={fullName}
            email={item.email}
          />
        ),
        company_name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {getCompanyName(item.companyName)}
          </MDTypography>
        ),
        company_website: (
          <MDTypography
            component="a"
            href={getCompanyWebsite(item.companyWebSite)}
            rel="noreferrer"
            target="_blank"
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {getCompanyName(item.companyWebSite)}
          </MDTypography>
        ),
        job_role: <Job title={item.jobRole || "N/A"} />,
        product_name: <Products myAPI={item?.myAPI} />,
        tech_status: (
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDBadge
              badgeContent={
                item?.myAPI?.length > 0
                  ? item.myAPI[0]?.techStatusDes
                  : "Pending"
              }
              color={getTechStatusColor(
                item?.myAPI?.length > 0 ? item.myAPI[0]?.techStatus : "P"
              )}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        registered_on: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(item.createdOn).format("MM/DD/yyyy")}
          </MDTypography>
        ),
        form: (
          <Button
            sx={{
              textTransform: "uppercase",
              borderRadius: "4px",
              color: "white !important",
              fontSize: "11px",
            }}
            variant="contained"
            size="small"
            onClick={() => {
              item.myAPI = handleMapAPI(item);
              setPriviousStatus(item.techStatus);
              setStatusValue(
                item?.myAPI?.length > 0 ? item.myAPI[0]?.techStatus : "P"
              );
              setSelectedItem(item);
              setErrorSandbox("");
              handleOpenForm();
              getFormDetails(item);
            }}
          >
            View Details
          </Button>
        ),
        action: (
          <Button
            sx={{
              textTransform: "uppercase",
              borderRadius: "4px",
              color: "white !important",
              fontSize: "11px",
            }}
            variant="contained"
            size="small"
            onClick={() => {
              item.myAPI = handleMapAPI(item);
              setStatusValue(
                item?.myAPI?.length > 0 ? item.myAPI[0]?.techStatus : "P"
              );
              setSelectedItem(item);
              handleOpen();
              setErrorSandbox("");
            }}
          >
            Update Status
          </Button>
        ),
      };
    });

    setRows(allUsers);
  };
  const errorAction = () => {
    setDataLoading(false);
  };

  const clearFields = () => {
    setSelectedItem();
    console.log("Identifire Trigger");
  };

  const style = {
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "20%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    FormModal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },
  };

  const fName = selectedItem?.firstName;
  const lName =
    selectedItem?.lastName !== null && selectedItem?.lastName !== undefined
      ? selectedItem?.lastName
      : "";
  const fullName = fName + " " + lName;

  const handleCSVDownload = () => {
    ShowSuccessMessage(dispatch, "Data exported successfully");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
        <MDBox mb={3} mt={2}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <Grid
                  container
                  spacing={6}
                  p={2}
                  sx={{ placeItems: "flex-end" }}
                >
                  <Grid item xs={12} xl={2}>
                    <FormControl fullWidth sx={{ height: "50px" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        variant="outlined"
                        color="success"
                        className="inputbox mb-2"
                      >
                        Tech Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedSandboxStatusTechTab}
                        label="Tech Status"
                        onChange={(e) => {
                          handleTabChangeSandboxTechStatus(e.target.value);
                        }}
                        sx={{ height: "50px" }}
                      >
                        <MenuItem value={"all"}>All</MenuItem>
                        <MenuItem value={"A"}>Approved</MenuItem>
                        <MenuItem value={"P"}>Pending</MenuItem>
                        <MenuItem value={"R"}>In Review</MenuItem>
                        <MenuItem value={"W"}>Rejected</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} xl={9} p={0} className="padd-zero"></Grid>
                  {user_data?.customer?.roleId === 4 && (
                    <Grid
                      item
                      xs={12}
                      xl={1}
                      sx={{ justifyContent: "end", display: "flex" }}
                    >
                      <MDBox mr={1}>
                        {(() => {
                          if (
                            downloadData &&
                            ((Array.isArray(downloadData) &&
                              downloadData.length > 0) ||
                              typeof downloadData === "string")
                          ) {
                            return (
                              <CSVLink
                                data={downloadData}
                                className="white"
                                asyncOnClick={false}
                                filename={`Tech Requests.csv`}
                                onClick={handleCSVDownload}
                              >
                                <MDButton className="btn-spc" color="success">
                                  {!dataLoading ? (
                                    <span>Export</span>
                                  ) : (
                                    <CircularProgress color="white" size={22} />
                                  )}
                                </MDButton>
                              </CSVLink>
                            );
                          } else if (
                            Array.isArray(downloadData) &&
                            downloadData.length === 0
                          ) {
                            return <></>;
                          } else {
                            return (
                              <MDButton
                                className="btn-spc"
                                color="success"
                                sx={{ pointerEvents: "none" }}
                              >
                                <CircularProgress color="white" size={22} />
                              </MDButton>
                            );
                          }
                        })()}
                      </MDBox>
                    </Grid>
                  )}
                </Grid>
                <MDBox
                  pt={3}
                  pb={3}
                  display="flex"
                  justifyContent="center"
                  className="padd-zero"
                >
                  {dataLoading ? (
                    <CircularProgress color="success" size={30} />
                  ) : (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      entriesPerPage={true}
                      showTotalEntries={true}
                      canSearch={true}
                      noEndBorder={false}
                      setGlobalFilterAPI={(value) => {
                        GetAllUsersWithSandboxTech(
                          dispatchData,
                          successAction,
                          errorAction,
                          value,
                          "1",
                          "A",
                          "A",
                          selectedSandboxStatusTechTab
                        );
                      }}
                    />
                  )}
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="responsive-modal"
        >
          <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
            <MDBox sx={style.modal}>
              <MDBox onClick={handleClose} className="close-modal-sm">
                <CloseRounded color={darkMode ? "white" : "secondary"} />
              </MDBox>
              <MDTypography variant="h5" sx={{ textTransform: "Capitalize" }}>
                {fullName}
              </MDTypography>
              <MDTypography variant="p" sx={{ fontSize: "14px" }} mb={4}>
                {selectedItem?.email}
              </MDTypography>
              {/* <MDInput type="email" label="Email Address" color="success" variant="outlined" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} fullWidth className="inputbox mb-2" required /> */}

              {/* Sanbox Tab */}
              <MDBox
                mb={3}
                sx={{
                  border: 1,
                  borderColor: "grey.400",
                  borderRadius: 2,
                  padding: "12px",
                }}
              >
                <FormGroup>
                  {selectedItem?.myAPI.map((item) => (
                    <MDBox key={item}>
                      <CustomCheckBox
                        product={item}
                        handleProductChange={(id, value) => {
                          handleCheckboxChanged(id, value);
                        }}
                      />
                    </MDBox>
                  ))}
                </FormGroup>
              </MDBox>
              <FormControl fullWidth sx={{ height: "50px" }}>
                <InputLabel
                  id="demo-simple-select-label"
                  variant="outlined"
                  color="success"
                  className="inputbox mb-2"
                >
                  Tech Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={statusValue}
                  label="Tech Status"
                  onChange={(e) => {
                    setStatusValue(e.target.value);
                    updateAPIStatuses(e.target.value);
                  }}
                  sx={{ height: "50px" }}
                >
                  <MenuItem value={"A"}>Approve</MenuItem>
                  <MenuItem value={"P"}>Pending</MenuItem>
                  <MenuItem value={"R"}>In Review</MenuItem>
                  <MenuItem value={"W"}>Rejected</MenuItem>
                </Select>
              </FormControl>
              {successSandbox && (
                <MDTypography
                  color="success"
                  variant="subtitle1"
                  sx={{ fontSize: "12px" }}
                >
                  Status changed successfully!
                </MDTypography>
              )}
              {failedSandbox && (
                <MDTypography
                  color="error"
                  variant="subtitle1"
                  sx={{ fontSize: "12px" }}
                >
                  There was an error submitted the request
                </MDTypography>
              )}
              {errorSandbox && (
                <MDTypography
                  color="error"
                  variant="subtitle1"
                  sx={{ fontSize: "12px" }}
                >
                  {errorSandbox}
                </MDTypography>
              )}
              <MDButton
                className="btn-update mt-3 px-2 py-3"
                sx={{ paddingLeft: 6.5, paddingRight: 6.5 }}
                variant="gradient"
                color="success"
                onClick={() => {
                  handleSubmitSandbox();
                }}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  `Update Status`
                )}
              </MDButton>
            </MDBox>
          </div>
        </Modal>

        <Modal
          open={openForm}
          onClose={handleCloseForm}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="responsive-modal"
        >
          <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
            <MDBox sx={style.FormModal}>
              <MDBox onClick={handleCloseForm} className="close-modal-sm">
                <CloseRounded color={darkMode ? "white" : "secondary"} />
              </MDBox>
              <MDTypography
                variant="h4"
                sx={{
                  textTransform: "capitalize",
                  textAlign: "center",
                  marginBottom: "25px",
                }}
              >
                API Onboarding Form
              </MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <Field label="Name" content={fullName} />
                  <Field
                    label="What is target to Go Live date?"
                    content={moment(identifier?.dateofLive).format(
                      "MM/DD/yyyy"
                    )}
                  />
                  <Field
                    label="Which Asset Classes will be sent?"
                    content={identifier?.assetClassesName}
                  />
                  <Field
                    label="Are there any latency requirements?"
                    content={identifier?.latencyRequirement}
                  />
                  <Field
                    label="Where will the servers be hosted?"
                    content={identifier?.serversHosting}
                  />
                  <Field
                    label="Which system prospect would be using to connect to API?"
                    content={identifier?.systemType}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Field label="Email" content={selectedItem?.email} />
                  <Field
                    label="Where will the clearing be done?"
                    content={identifier?.clearingArea}
                  />
                  <Field
                    label="Count of messages expected per day?"
                    content={identifier?.msgsPerDayCount}
                  />
                  <Field
                    label="Where will this business be routed?"
                    content={identifier?.businessRouting}
                  />
                  <Field
                    label="How many messages per second and peak number"
                    content={identifier?.msgsPerSecond}
                  />
                  <Field
                    label="Risk check to be done through Succession?"
                    content={identifier?.riskCheck === false ? "Yes" : "No"}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </div>
        </Modal>
      </div>
      <Footer />
    </DashboardLayout>
  );
}
Author.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};
Job.propTypes = {
  title: PropTypes.string.isRequired,
};
Products.propTypes = {
  myAPI: PropTypes.arrayOf(
    PropTypes.shape({
      apiid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
CustomCheckBox.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleProductChange: PropTypes.func.isRequired,
};
CustomCheckBox.propTypes = {
  product: PropTypes.shape({
    apiid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  // handleChange: PropTypes.func.isRequired,
};
Field.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
export default Users;
